import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();
  const productName = "PolitePay"; // Updated to actual name

  return (
    <footer className="py-6 md:py-8 bg-white border-t border-gray-100">
      <div className="container mx-auto px-4 md:px-6 text-center text-sm">
        <p className="text-primary-light">&copy; {currentYear} {productName}. All rights reserved.</p>
        {/* Optional: Add links later */}
        {/* <div className="mt-2">
          <a href="/privacy" className="text-accent hover:text-accent-light transition">Privacy Policy</a>
          <span className="mx-2 text-gray-300">|</span>
          <a href="/terms" className="text-accent hover:text-accent-light transition">Terms of Service</a>
        </div> */}
      </div>
    </footer>
  );
}

export default Footer; 